import axios from 'axios';
import { Notification } from '../notification/notfication';
import Axios from 'axios';
import utils from '../utils/utils';

export const API = {
    config: {
        headers: {'Access-Control-Allow-Origin': '*'}
    },

    get: (url: string, options?: Object) => {
        options = Object.assign(API.config, options);

        return new Promise((resolve, reject) => {
            axios.get(url, options).then((data) => {
                resolve(data);
            }).catch((error) => {
                reject(error)
            });
        });
    },

    post: (action: string, forceReload: boolean = false, data = {}, addServerId: boolean = true, loadingElement?: string) => {
        let url = API.buildUrl(action, addServerId, true);
        if (loadingElement) {
            $(loadingElement).addClass('is-loading');
        }
        Axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            let message = 'Your changes was saved successfully.';
            if (utils.isSet(response, 'data', 'message')) {
                message = response.data.message;
            }
            new Notification('success', 'Oki Doki :)', message);
            if (forceReload) {
                window.location.reload();
            }
        }).catch((error) => {
            let message = 'Something went wrong. Please try again later.';
            if (utils.isSet(error, 'response', 'data', 'message')) {
                message = error.response.data.message;
            }
            new Notification('danger', 'Oops…', message)
        }).then(value => {
            if (loadingElement) {
                $(loadingElement).removeClass('is-loading');
            }
        });
    },

    buildUrl: (action: string, addServerId: boolean = false, useAjaxPath: boolean = false) => {
        if (window.debug) {
            console.log('API.buildUrl: window.basePath = ' + window.basePath);
            console.log('API.buildUrl: window.ajaxPath = ' + window.ajaxPath);
        }

        let url = window.basePath + action;
        if (useAjaxPath) {
            url = window.ajaxPath + '/' + action;
        }

        if (addServerId) {
            url += '/' + window.serverId;
        }

        if (window.debug) {
            console.log('API.buildUrl: url = ' + url);
        }

        return url;
    }
};
